/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get("pagination")) {
    class Pagination extends HTMLElement {
        constructor() {
            super();
            const id = this.dataset.section;
            this.button = this.querySelector(".load-more");
            this.grid = document.querySelector("[data-id=" + id + "]");
            this.animations_enabled = document.body.classList.contains("animations-true") && typeof gsap !== "undefined";
            this.i = 2;
        }
        connectedCallback() {
            if (this.classList.contains("pagination-type--loadmore")) {
                this.loadMore();
            }
            if (this.classList.contains("pagination-type--infinite")) {
                this.infinite();
            }
        }
        addUrlParam(search, key) {
            var newParam = key + "=" + this.i,
                params = "?" + newParam;

            // If the "search" string exists, then build params from it
            if (search) {
                // Try to replace an existance instance
                params = search.replace(new RegExp("([?&])" + key + "[^&]*"), "$1" + newParam);

                // If nothing was replaced, then add the new param to the end
                if (params === search) {
                    params += "&" + newParam;
                }
            }

            return params;
        }
        loadMore() {
            let base = this;
            this.button.addEventListener("click", function () {
                base.loadProducts();
                this.blur();
                return false;
            });
        }
        infinite() {
            let base = this;
            // Añadir un retraso para evitar múltiples cargas
            let debounceTimer;

            base.observer = new IntersectionObserver(
                function (entries) {
                    if (entries[0].intersectionRatio > 0.5) {
                        // Reducido de 1 a 0.5
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(() => {
                            // console.log("load products", performance.now());
                            base.loadProducts();
                        }, 300); // Retraso de 300ms
                    }
                },
                {
                    threshold: [0, 0.5], // Cambiado de [0, 1] a [0, 0.5]
                },
            );
            base.observer.observe(base);
        }
        loadProducts() {
            let base = this,
                url = document.location.pathname + base.addUrlParam(document.location.search, "page");
            // Si ya está cargando, no hace nada
            if (base.getAttribute("loading")) {
                return;
            }

            base.i++;
            base.setAttribute("loading", true);

            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Error en la respuesta de red");
                    }
                    return response.text();
                })
                .then((responseText) => {
                    const html = responseText;
                    base.renderProducts(html, url);

                    dispatchCustomEvent("pagination:page-changed", {
                        url: url,
                    });
                })
                .catch((error) => {
                    console.error("Error de paginación:", error);
                    base.removeAttribute("loading");

                    // Reintentar después de un tiempo si fue un error temporal
                    setTimeout(() => {
                        base.i--; // Retroceder el contador para reintentar la misma página
                    }, 3000);
                });
        }
        renderProducts(html) {
            let base = this,
                parsed_html = new DOMParser().parseFromString(html, "text/html"),
                grid_to_replace = parsed_html.getElementById("product-grid"),
                count_to_replace = parsed_html.getElementById("ProductCount");

            if (!grid_to_replace || grid_to_replace.classList.contains("collection-empty")) {
                if (base.observer) {
                    base.observer.unobserve(base);
                }
                base.removeAttribute("loading");

                if (base.button) {
                    base.button.classList.add("visually-hidden");
                }
                return;
            }

            let products = grid_to_replace.querySelectorAll(".column");

            // Limitar el número de productos que se añaden al DOM
            const maxProductsPerPage = 24; // Ajusta según tus necesidades
            let productsToAdd = products.length > maxProductsPerPage ? maxProductsPerPage : products.length;

            for (var i = 0; i < productsToAdd; i++) {
                products[i].dataset.pagination = base.i;
                this.grid.appendChild(products[i]);
            }

            // Optimizar animaciones
            if (this.animations_enabled) {
                let added_columns = this.grid.querySelectorAll('[data-pagination="' + base.i + '"]'),
                    to_animate = [];

                // Reducir animaciones en móviles
                const isMobile = window.innerWidth < 768;
                const staggerValue = isMobile ? 0.05 : 0.15;

                for (var j = 0; j < added_columns.length; j++) {
                    const element = added_columns[j].querySelector(".product-card .product-featured-image-link, .products .gallery--item figure");
                    if (element) {
                        to_animate.push(element);
                    }
                }

                // Matar animaciones anteriores si existen
                if (base.animation) {
                    base.animation.kill();
                }

                // Almacenar referencia a la animación actual
                base.animation = gsap.to(to_animate, {
                    scale: 1,
                    opacity: 1,
                    stagger: staggerValue,
                    ease: window.theme.settings.animation_easing,
                    onComplete: () => {
                        // Limpiar referencia después de completar
                        base.animation = null;
                    },
                });
            }

            base.removeAttribute("loading");

            // Actualizar contadores
            if (count_to_replace) {
                const container = document.getElementsByClassName("thb-filter-count");
                for (var item of container) {
                    item.innerHTML = count_to_replace.innerHTML;
                }
            }
        }
    }
    customElements.define("pagination-theme", Pagination);
}
